<template>
<v-btn v-show="!hideButton" :block="phoneOnly" depressed @click="load" color="primary" large rounded min-width="250px">
    <v-icon left>mdi-message-processing-outline</v-icon>
    <strong>ابدأ المحادثة</strong>
</v-btn>
</template>

<script>
import { Crisp } from "crisp-sdk-web";

let sessionOwner;
let sessionWebsite;

export default {
    props: {
        user: {required: true},
        websiteId: {required: true},
        // يتخفي لما الصفحة بتفتح كريسب من مكان تاني (زي التحويل من شات الـ AI)
        hideButton: {type: Boolean, default: false},
    },
    data(){
        return {
            Crisp: null,
        }
    },
    computed: {
        pcOnly(){
            return this.$vuetify.breakpoint.mdAndUp;
        },
        mdAndUp(){
            return this.$vuetify.breakpoint.smAndUp;
        },
        phoneOnly(){
            return !this.pcOnly;
        },
    },
    methods: {
        syncUser() {
            if (!this.Crisp) return;
            const id = this.user && this.user.id != null ? String(this.user.id) : null;
            try {
                const saved = JSON.parse(window.localStorage.getItem('derasa-crisp-owner'));
                if (saved) { sessionOwner = saved.id; sessionWebsite = saved.websiteId; }
            } catch (error) { /* Storage is optional. */ }
            if (sessionOwner !== id || sessionWebsite !== this.websiteId) this.Crisp.session.reset();
            try { window.localStorage.setItem('derasa-crisp-owner', JSON.stringify({ id, websiteId: this.websiteId })); } catch (error) { /* optional storage */ }
            sessionOwner = id;
            sessionWebsite = this.websiteId;
            if (!this.user) return;
            if (this.user.email) this.Crisp.user.setEmail(this.user.email);
            this.Crisp.user.setCompany('Profile', {url: process.env.VUE_APP_PRODUCTION_API_URL.replace('api.', 'dashboard.').replace('/v1', `/users/${this.user.id}`), description: 'Profile URL'});
            if (this.user.avatar) this.Crisp.user.setAvatar(this.user.avatar);
            if (this.user.name) this.Crisp.user.setNickname(this.user.name);
            this.Crisp.session.setData({ user_id: id, phone: this.user.phone || '', app_url: process.env.VUE_APP_WEB_APP_URL });
        },
        load(){
            // this.Crisp.load();
            this.Crisp.chat.show();
            this.Crisp.chat.open();
        },
        close(){
            if (!this.Crisp) return;

            this.Crisp.chat.close();
            this.Crisp.chat.hide();
        },
        /**
         * تحويل محادثة الـ AI لموظف دعم بشري.
         * الملخص بيتبعت كرسالة افتتاحية عشان الموظف يلاقي المحادثة كاملة قدامه.
         */
        escalate(summary, conversationId){
            if (!this.Crisp) return;

            // كريسب بيكمل في المحادثة المفتوحة، فبنفتح thread جديد
            // عشان كل تحويل يبقى محادثة مستقلة زي زرار "بدء محادثة جديدة"
            this.Crisp.message.startThread(`الدعم الذكي #${conversationId}`);

            this.Crisp.session.setData({
                ai_support_conversation_id: conversationId || '',
            });
            this.Crisp.session.setSegments(['ai-escalation'], true);

            this.load();

            // كريسب بيرفض الرسايل الطويلة، فبنقسم الملخص
            this.chunkText(summary, 1900).forEach(part => {
                this.Crisp.message.send('text', part);
            });
        },
        chunkText(text, size){
            const value = (text || '').toString().trim();
            if (!value) return [];

            const parts = [];
            for (let i = 0; i < value.length; i += size){
                parts.push(value.slice(i, i + size));
            }
            return parts;
        },
    },
    watch: {
        user: { deep: true, handler() { this.syncUser(); } },
    },
    mounted(){
        this.Crisp = Crisp;
        this.Crisp.configure(this.websiteId, { autoload: false, locale: 'ar' });
        this.Crisp.chat.hide();
        this.syncUser();
        this.Crisp.chat.onChatClosed(() => this.Crisp.chat.hide());
        this.Crisp.chat.hide();
    },
    beforeDestroy(){
        if (this.Crisp){
            this.Crisp.chat.offChatClosed();
            this.Crisp.chat.close();
            this.Crisp.chat.hide();
        }
    }
}
</script>
